import actionTypes from '../constants/action-types';

const addCustomTextColor = (color) => ({
  type: actionTypes.ADD_CUSTOM_TEXT_COLOR,
  payload: {
    color,
  },
});

export default addCustomTextColor;
